// removed by extract-text-webpack-plugin
module.exports = {"fieldset":"radio-group__fieldset___2fEuQ","legend":"radio-group__legend___2d6aM","itemContainer":"radio-group__item-container___2azql","item":"radio-group__item___3YI6e","itemDisabled":"radio-group__item--disabled___2oOz0"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/radio-group/radio-group.scss
// module id = 254
// module chunks = 1